import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {Util} from "../base/util";
import {map} from "rxjs/operators";
import {ConfigProvider} from "../base/config";

/*
 Generated class for the RotinaProvider provider.

 See https://angular.io/guide/dependency-injection for more info on providers
 and Angular DI.
 */
@Injectable()
export class RotinaProvider {

    public ressourceUrl: any = ConfigProvider.host + '/api/v1/front/saude/rotina';

    constructor(public http: HttpClient) {
    }

    horariosByMes(mes, especialidade, prestador, params: any = {}, headers: HttpHeaders = null): Observable<any> {
        return this.http.get(this.ressourceUrl + `/horarios-mes/${mes}/${especialidade}/${prestador}`, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                for (let i = 0; i < response.data.length; i++) {
                  if(!Util.isNullOrUndefined(response.data[i].dt_horario_inicio))
                    response.data[i].dt_horario_inicio = Util.convertDateHourForIos(response.data[i].dt_horario_inicio);
                    response.data[i].dt_horario_fim = Util.convertDateHourForIos(response.data[i].dt_horario_inicio);
                }
                response['daysConfig'] = [];
                response.data.forEach((item, index) => {
                    response['daysConfig'].push({
                        date: item.dt_horario_inicio,
                        marked: true
                    })
                });
                return response;
            })
        );
    }

    horariosRotina(rotina, params: any = {}, headers: HttpHeaders = null): Observable<any> {
        return this.http.get(this.ressourceUrl + `/horarios-rotina/${rotina}`, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                response.data.forEach((item, index) => {
                    response.data[index].novo_id = item.id;
                    response.data[index].data_label = Util.transformDate(Util.convertDateHourForIos(item.dt_horario_inicio),'HH:mm - dd/MM/yyyy');
                });
                return response;
            })
        );
    }

    horariosServico(servico, params: any = {}, headers: HttpHeaders = null): Observable<any> {
        return this.http.get(this.ressourceUrl + `/horarios-servico/${servico}`, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                response.data.forEach((item, index) => {
                    response.data[index].novo_id = item.id;
                    response.data[index].data_label = Util.transformDate(Util.convertDateHourForIos(item.dt_horario_inicio),'dd/MM/yyyy às HH:mm');
                });
                return response;
            })
        );
    }
}



// WEBPACK FOOTER //
// ./src/providers/rotina/rotina.ts